/** @jsx jsx */
import { Box, Container } from "@eworkit/iris";
import { FC, useCallback, useMemo } from "react";
import { jsx } from "theme-ui";

import { AppSuspense } from "@/components/app";
import { IContract } from "@/data/contracts";
import { RoutedTabPanels } from "@/router/RoutedTabPanels";

import { ContractDetails } from "./ContractDetails";
import { ContractTasks } from "./ContractTasks";

interface ContractDetailsPanelsProps {
  contract: IContract;
}

export const ContractDetailsTabPanels: FC<ContractDetailsPanelsProps> = ({ contract }) => {
  const details = useCallback(() => <ContractDetails contract={contract} />, [contract]);

  const tasks = useCallback(() => <ContractTasks tasks={contract.tasks} />, [contract.tasks]);

  const tabPanels = useMemo(
    () => ({
      details,
      tasks,
    }),
    [details, tasks],
  );

  return (
    <Container>
      <Box px={[null, null, null, "sm"]} py={["xs", null, null, "md"]}>
        <AppSuspense>
          <RoutedTabPanels routeParam="tab" views={tabPanels} />
        </AppSuspense>
      </Box>
    </Container>
  );
};
